/**
 * Utilidad para detectar el tenant desde el navegador
 * En producción: detecta desde el subdominio (ea.sinamonsoft.ar → EA)
 * En desarrollo: usa variable de entorno o valor por defecto
 */

/**
 * Obtiene el dominio completo del tenant desde el hostname del navegador
 * @returns {string} Dominio completo (ej: "prueba.sinamonsoft.ar")
 */
export function getTenantFromBrowser() {
  const host = window.location.hostname;

  // Producción: retornar el hostname completo
  // Ejemplo: prueba.sinamonsoft.ar → prueba.sinamonsoft.ar
  if (!host.includes('localhost') && !host.includes('127.0.0.1')) {
    return host.toLowerCase();
  }

  // Desarrollo: usar variable de entorno o fallback
  // Puedes configurar VITE_DEFAULT_TENANT en .env con dominio completo
  return import.meta.env.VITE_DEFAULT_TENANT || 'demo.sinamonsoft.ar';
}

/**
 * Obtiene la información del tenant guardada en localStorage
 * @returns {object|null} Información del tenant o null si no existe
 */
export function getStoredTenant() {
  try {
    const stored = localStorage.getItem('tenant');
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.warn('Error al leer tenant del localStorage:', error);
    return null;
  }
}

/**
 * Guarda la información del tenant en localStorage
 * @param {object} tenantInfo - Información del tenant
 */
export function storeTenant(tenantInfo) {
  try {
    localStorage.setItem('tenant', JSON.stringify(tenantInfo));
  } catch (error) {
    console.warn('Error al guardar tenant en localStorage:', error);
  }
}

/**
 * Elimina la información del tenant del localStorage
 */
export function clearTenant() {
  try {
    localStorage.removeItem('tenant');
  } catch (error) {
    console.warn('Error al limpiar tenant del localStorage:', error);
  }
}
